/* eslint-disable react/jsx-props-no-spreading */
import { useUrlGenerator } from '@micromag/core/contexts';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useUser } from '../../contexts/AuthContext';
import LinkButton from '../buttons/Link';
import MainLayout from '../layouts/Main';
import UserStoriesMenubar from '../menubars/UserStories';
import AllStories from '../partials/AllStories';
import Page from '../partials/Page';

import styles from '../../../styles/pages/home.module.scss';

const propTypes = {
    maxOrganisations: PropTypes.number,
    className: PropTypes.string,
};

const defaultProps = {
    maxOrganisations: 4,
    className: null,
};

const HomePage = ({ maxOrganisations, className }) => {
    const { organisations: userOrganisations = [] } = useUser();
    const organisations = userOrganisations || [];

    const url = useUrlGenerator();
    const organisationsItems = useMemo(() => {
        const items = organisations.map((it) => ({
            id: it.id,
            href: url('organisations.switch', {
                organisation: it.slug,
            }),
            external: true,
            label: it.name,
            active: false,
            target: '_self',
        }));
        return items.length > maxOrganisations ? items.slice(0, maxOrganisations) : items;
    }, [maxOrganisations]);

    return (
        <MainLayout nav={[]}>
            <Page
                title={<FormattedMessage defaultMessage="My Micromags" description="Page title" />}
                menubar={<UserStoriesMenubar />}
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
                headerClassName="pb-1"
            >
                <div className="d-flex mb-4 align-items-center flex-wrap">
                    <span className="text-nowrap pe-2">
                        <FormattedMessage
                            defaultMessage="My organisations :"
                            description="Menu label"
                        />
                    </span>
                    {organisationsItems.map((org) => (
                        <LinkButton key={org.id} className="flex-wrap me-2 text-nowrap" {...org} />
                    ))}
                    {organisations.length > maxOrganisations ? (
                        <FormattedMessage defaultMessage="and more" description="Menu label" />
                    ) : null}
                </div>
                <AllStories withSearch />
            </Page>
        </MainLayout>
    );
};

HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

export default HomePage;
